import React from "react";

import { Field, FieldLabel } from "../../../../components/FormPanel";
import { FormInput } from "../../../../components/Input";
import { SYMBOL_RULES } from "./constants";
import { EditorFieldsProps } from "./types";

export const SymbolField: React.FC<EditorFieldsProps> = ({
  control,
  disabled,
}) => (
  <Field>
    <FieldLabel htmlFor="instrument-editor-symbol">Symbol</FieldLabel>
    <FormInput
      id="instrument-editor-symbol"
      name="symbol"
      control={control}
      rules={SYMBOL_RULES}
      disabled={disabled}
    />
  </Field>
);
